export default "__VITE_ASSET__BHaSt2hV__"